<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"
  (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents">
  <div class="subBlockContainer">
    <div class="breadcrumbWrapper">
      <app-breadcrumb></app-breadcrumb>
    </div>

    <div class="child-loader">
      <div class="subBlockContainer toplevel" [ngStyle]="{'width': toplevelWidth}">
        <div class="subBlockContent" id="cataloguelist">
          <child-header [title]="title" (closeEvent)="close()" [showSubscription]="true" [editMode]="true"
            (subscriptionEvent)="navigateTo('catalogues/subscriptions')"
            [menuDownloadItems]="['Download Subscribed to Excel']"
            (menuDownloadEvent)="onMenuDownload($event)"></child-header>
          <div class="inner-subBlock-wrapper">
            <div class="page-title-wrapper" style="display: none;">
              <div class="title blade-title-font">
                <span id="subscriptionButton" class="basic-icon subscription-icon" placement="bottom"
                  ngbTooltip="Subscription" [routerLink]="['subscriptions']"></span>
                <ng-template #popContent>
                  <button type="button" class="close" aria-label="Close" (click)="closeDownload()">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div class="popover-inner-wrapper">
                    <span (click)="sendAllNewsletters(accountId, popContent, $event)">Download All to Excel</span>
                  </div>
                </ng-template>

                <span #popover="ngbPopover" id="downloadButton" class="basic-icon download-icon" placement="bottom"
                  [ngbPopover]="popContent" triggers="manual" (click)="openPop();"
                  [ngClass]="{'active-icon' : iconCanbeActive, 'default-icon': !iconCanbeActive }"></span>
              </div>
            </div>
            <p class="explore-by">Explore by</p>
            <div class="mat-button-toggle">
              <mat-button-toggle-group name="filter" [(ngModel)]="selectedFilter">
                <mat-button-toggle value="categories" (change)="onChangeFilter()"
                  class="categories-checked">Categories</mat-button-toggle>
                <mat-button-toggle value="brands" (change)="onChangeFilter()"
                  class="brands-checked">Brands</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <mat-chip-list class="matChips-list" multiple>
              <mat-chip color="accent"
                [selected]="selectedFilter == 'categories' ? allCategorySelected : allBrandSelected"
                class="mat-chip-accent" (click)="onChangeAll()">All</mat-chip>
              <ng-container *ngIf="selectedFilter == 'categories'">
                    <ng-container *ngFor="let data of categorisedData">
                      <mat-chip color="accent" *ngIf = "data?.newsletters?.length > 0"
                      (click)="onChangeCategory('category',data)" class="mat-chip-accent"
                      [selected]="data.category.selected"
                     >{{data.category.category}}</mat-chip>
                    </ng-container>

              </ng-container>
              <ng-container *ngIf="selectedFilter == 'brands'">
                <mat-chip color="accent" style="cursor: pointer;" *ngFor="let data of filteredData"
                  [disabled]="data.disabled" (click)="onChangeBrand('brand',data)" [selected]="data.selected"
                  class="mat-chip-accent">{{data.name}}</mat-chip>
              </ng-container>
            </mat-chip-list>
            <div class="row filter-wrapper mb-4">
              <div class="">
                <div class="searchInputGroup">

                  <input class="searchInput" type="text" placeholder="Search keywords"
                    [(ngModel)]="catalogueFilterValue"  pattern="[A-Za-z]+" (ngModelChange)="onChange($event)" #filterInput>
                  <div class="searchIcon new-searchIcon">
                    <img src="../images/catalogue/search.png">
                  </div>
                </div>
              </div>

              <!-- # brand filter -->
              <div class="col-md-2 d-none">
                <mat-form-field class="select-wrapper" (click)="tickAllOptionsByOpeningPanel($event)">
                  <mat-select #matSelect placeholder="Brand" multiple [(ngModel)]="selectedBrands"
                    #brandSelect="ngModel" (selectionChange)="updateBrandList(brandSelect)" (ngModelChange)="onChange($event)"
                    (openedChange)="openedChange($event)">
                    <mat-select-trigger>
                      <span *ngIf="selectedBrands[0] === 'all'">
                        {{selectedBrands ? selectedBrands[1] : ''}}
                        <span *ngIf="selectedBrands?.length > 1" class="example-additional-selection">
                          (+{{selectedBrands.length - 2}} other(s))
                        </span>
                      </span>

                      <span *ngIf="selectedBrands[0] !== 'all'">
                        {{selectedBrands ? selectedBrands[0] : ''}}
                        <span *ngIf="selectedBrands?.length > 1" class="example-additional-selection">
                          (+{{selectedBrands.length - 1}} other(s))
                        </span>
                      </span>

                    </mat-select-trigger>
                    <mat-option #allSelected (click)="toggleAllSelection(brandSelect)" value="all">Select all
                    </mat-option>
                    <mat-option *ngFor="let item of fixedUniqueBrands | sortByAlphabeticPipe" [value]="item">
                      {{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- <div class=" align-right">
                  <span class="clearFilterButton primary-red-button" (click)="filterReset()"
                    *ngIf="hasFilterChanged || selectedBrands?.length">
                    Clear filter</span>
                  <span class="primary-red-button font-color-p1" (click)="switchCatalogueMode()"
                    *ngIf="currentUserModel?.isStaffAccount">
                    Switch to edit mode</span> 
                </div> -->
            </div>
            <!-- EMPTY RESULTS -->
            <ng-container *ngIf="hasEmptyResult">
              <div class="noResult-wrapper">
                <div><img src="../images/new_ui/no-found.png"></div>
                <div>No results found</div>
                <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
                <button class="button button-red button-large" (click)="filterReset()">Try again</button>

              </div>
            </ng-container>

            <ng-container *ngIf="loadContent && !hasEmptyResult">
              <!-- MAT TABLE FOR DYNAMIC ACCORDIAN GENERATION -->
              <mat-accordion multi>
                <div class="accordian-header">
                  <div class="cursor-pointer" (click)="filterSort()">
                    <img [style.transform]="rotateImage == 1 ? 'rotate(180deg)' : 'rotate(0deg)'"
                      src="../images/catalogue/sort-alpha-down.png" />
                    <span class="sort-text ml-1">Sort</span>
                  </div>
                  <ng-container *ngIf="selectedFilter == 'categories'">
                    <span class="sort-text cursor-pointer" *ngIf="toggleData"
                      (click)="toggleData = false; accordion.closeAll()">
                      Collapse all
                    </span>
                    <span class="sort-text cursor-pointer" *ngIf="!toggleData"
                      (click)="toggleData = true; accordion.openAll()">
                      Expand all
                    </span>
                  </ng-container>
                </div>
                <ng-container *ngFor="let cat of selectedCategoryData">
                  <!-- [expanded]="accordianExpanded(cat.category.id)" -->
                  <mat-expansion-panel *ngIf="cat.newsletters.length > 0 && selectedFilter == 'categories'"
                    #panels
                    >
                    <mat-expansion-panel-header>
                      <mat-panel-title class="highlight-text panel-header-title">
                        <span>{{cat.category.category}}</span>
                      </mat-panel-title>
                      <mat-panel-description class="panel-subtitle">
                        <span class=""></span>
                      </mat-panel-description>
                      <mat-panel-description class="highlight-text panel-subtitle panel-star">
                        <!-- CheckBox to subscribe to the category -->
                        <!-- <mat-checkbox *ngIf="cat.category.id != '-1'" class="highlight-text newsletter-favourite" (change)="saveSubscription(cat.category.id, $event)" [checked]="isSubscribed(cat.category.id)">
                          </mat-checkbox> -->
                        <img class="cursor-pointer"
                          (click)="saveSubscription(cat.category.id, $event)"
                          [src]="isSubscribed(cat.category.id) ? '../images/catalogue/push-pin-selected.png' : '../images/catalogue/push-pin.png'">
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <table matSort class="white width-100">
                      <tbody>
                        <!-- NEWSLETTER DATA -->
                        <ng-container *ngFor="let item of cat.newsletters">
                          <tr class="row brand-data" *ngIf="item?.published =='0'">
                            <td class="col-lg-2 col-md-2 col-sm-12">
                              <a class="result_desc" [routerLink]="['newsletter/'+ item?.news_id+'/'+item?.title]"
                                (click)="goToNewsletterView(item?.news_id)">{{item?.brand}}
                              </a>
                            </td>
                            <!-- <td class="col-lg-4 col-md-4 col-sm-12">
                                <a [routerLink]="['newsletter/'+ item?.news_id+'/'+item?.title]"
                                  (click)="goToNewsletterView(item?.news_id)">{{item?.title}}
                                </a>
                              </td> -->
                            <td class="col-lg-8 col-md-8 col-sm-12"><span>{{item?.description}}</span></td>
                            <td
                              class="col-lg-2 col-md-2 col-sm-12 align-right d-flex justify-content-end align-items-center">
                              <div id="catDownloadButton" class="basic-icon download-icon float-left"
                                (click)="exportExcelForCatalogue(item?.news_id)"></div>
                              <div>
                                <a [routerLink]="['newsletter/'+ item?.news_id+'/'+item?.title]"
                                  (click)="goToNewsletterView(item?.news_id)" class="red-link">Details
                                </a>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </mat-expansion-panel>
                </ng-container>

                <ng-container *ngFor="let data of selectedBrandData">
                  <mat-expansion-panel *ngIf="brandsData.length > 0 && selectedFilter == 'brands'" hideToggle disabled>
                    <mat-expansion-panel-header class="cursor-auto">
                      <mat-panel-title class="highlight-text panel-header-title" class="highlight-text">
                        <span class="brandtitle">
                        <a class="brandtitle-color" [routerLink]="['newsletter/'+ data?.news_id+'/'+data?.title]" (click)="goToNewsletterView(data?.news_id)">{{data?.brand}}</a></span>
                      </mat-panel-title>
                      <mat-panel-description class="panel-subtitlebrand">
                        <span class="brand-text">{{data?.description}}</span>
                      </mat-panel-description>
                        <div class="d-flex justify-content-end align-items-center">
                          <div id="catDownloadButton" class="basic-icon download-icon float-left"
                            (click)="exportExcelForCatalogue(data?.news_id)"></div>
                          <a [routerLink]="['newsletter/'+ data?.news_id+'/'+data?.title]"
                            (click)="goToNewsletterView(data?.news_id)" class="red-link">Details
                          </a>
                        </div>
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
                </ng-container>
              </mat-accordion>
            </ng-container>
          </div>
          <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
          </loading-screen>
          <loading-screen *ngIf="!finishDownLoading"> </loading-screen>
        </div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>